<template lang="">
  <div class="contents">
    <div class="signUp_wrap">
        <div class="signUp_head">
            <h5 class="tit">회원가입</h5>
            <ul class="step">
                <li class="on">01. 약관동의</li>
                <li>02. 정보입력</li>
                <li>03. 가입완료</li>
            </ul>
        </div>
        <div class="signUp_body">
            <div class="all_wrap">
                <div class="chk_wrap">
                    <input type="checkbox" id="Allchk" name="Allchk" v-model="allCheck">
                    <label for="Allchk" class="chk_btn">
                        <span>약관 전체 동의</span>
                    </label>
                </div>
            </div>
            <div class="agreement_wrap">
                <div class="agreement_box">
                    <h5>서비스 이용약관 동의 (필수)</h5>
                    <div class="txtBox_wrap">
                        <div class="txtBox">
                            제 1조 (목적)<br>
                            본 약관은 디지털로고스 디지털 화환 서비스(이하 ‘회사’라 함)가 운영하는 디지털로고스(이하 ‘몰’이라 함)에서 제공하는<br>
                            인터넷 관련 서비스를 이용함에 있어 ‘몰’과 ‘이용자’의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.<br>
                            <br>
                            제 2조 [용어의 정의]<br>
                            본 약관에서 사용하는 용어의 정의는 다음과 같습니다.<br>
                            1. "몰"이란 회사가 재화 또는 용역(이하 "재화 등"이라고 합니다)을 이용자에게 제공하기 위하여 컴퓨터, 핸드폰 등 정보통신설비를 이용하여 재화 또는<br>
                            용역 등을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 사이버몰을 운영하는 사업자의 의미로도 사용합니다.<br>
                            2. "이용자"란 "몰"에 접속하여 이 약관에 따라 "몰"이 제공하는 서비스를 받는 회원 및 비회원을 말합니다.<br>
                            3. "회원"이라 함은 "몰"에 개인정보를 제공하여 회원가입을 한 자로서, "몰"의 정보를 지속적으로 제공받으며, "몰"이 제공하는 서비스를 계속적으로<br>
                            이용할 수 있는 자를 말합니다.<br>
                            4. "비회원"이라 함은 회원에 가입하지 않고 "몰"이 제공하는 서비스를 이용하는 자를 말합니다.<br>
                            5. "적립금"이란 "몰"이 특정 재화 등을 구입한 이용자 또는 경품 등의 목적으로 이용자에게 부여한 사이버머니를 말하며, 적립금의 부여 및 사용 등과<br>
                            관련한 사항은 이 약관 또는 "몰"의 운영정책이 정한 바에 따릅니다.<br>
                            6. 서비스 : 회사가 제공하는 인터넷상의 모든 서비스를 말합니다.<br>
                            7. 아이디 : 회원의 식별과 회원의 서비스이용을 위하여 문자나 숫자 혹은 그 조합을 말합니다(이하 "ID"라 합니다).<br>
                            8. 비밀번호 : 회원이 부여 받은 ID와 일치된 회원임을 확인하고, 회원의 권익 및 비밀보호를 위하여 회원 스스로가 선정하여 “몰”에 등록한 문자와<br>
                            숫자의 조합을 말합니다.<br>
                            9. 서비스제공 제한·중지 : 공공의 이익 규정에 위배되는 경우에 회원에게 제공하는 서비스의 전부 또는 일부를 제한하거나 중지하는 것을 말합니다.<br>
                            <br>
                            제 29조 【분쟁의 해결】<br>
                            ① 회사와 회원은 서비스와 관련하여 분쟁이 발생한 경우에 이를 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다.<br>
                            ② 제1항의 규정에도 불구하고, 동 분쟁으로 인하여 소송이 제기될 경우 동 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는<br>
                            지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다.<br>
                            ③ "회사"와 이용자간에 제기된 전자상거래 소송에는 한국법을 적용합니다.<br>
                        </div>
                        <div class="chk_wrap">
                            <input type="checkbox" id="agree01" name="agree01" v-model="usageAgree">
                            <label for="agree01" class="chk_btn">
                                <span>블러썸로고스의 이용약관 내용에 동의합니다.</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="agreement_box">
                    <h5>개인정보의 제공 및 활용 동의 (필수)</h5>
                    <div class="txtBox_wrap">
                        <div class="txtBox">
                            개인정보취급방침<br>
                            '디지털로고스'는 (이하 "회사" 라 한다) 이용자의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다.<br>
                            회사는 개인정보취급방침을 통하여 이용자가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가<br>
                            취해지고 있는지 알려드립니다. 만일 개인정보취급방침을 개정하는 경우에는 웹사이트 공지사항(또는 개별공지)을 통하여 안내해 드립니다.<br>
                            <br>
                            1. 수집하는 개인정보의 항목 및 수집방법<br>
                            회사는 원활한 고객상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다. 단, 이용자의 기본적 인권 침해의 우려가 있는 민감한<br>
                            개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다.<br>
                            <br>
                            1) 수집하는 개인정보의 항목<br>
                            - 필수항목 : 이름,휴대전화번호,전자우편주소,희망ID(회원의 경우),비밀번호(회원의 경우)<br>
                            - 선택항목 : 생년월일,전화번호,주소,뉴스레터/SMS 수신여부<br>
                            - 자동수집항목 : IP Adreess, 방문일시, 쿠키정보<br>
                            <br>
                            2) 개인정보의 수집방법<br>
                            인터넷 회원가입, 전화, 상담 게시판, 이벤트 응모, 제휴사로 부터의 제공, 배송요청<br>
                            <br>
                            3) 수집 및 이용 목적<br>
                            - 회원 관리(본인확인, 개인식별, 부정이용 방지와 비인가사용 방지, 가입의사 확인, 연령확인, 불만처리 등 민원처리, 고지사항 전달)<br>
                            - 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산, 컨텐츠 제공, 서비스 및 가입상담<br>
                            - 마케팅/광고 활용 (이벤트 등 광고성 정보전달 , 인구통계학적 특성에 따른 서비스 제공 및 광고 게재<br>
                        </div>
                        <div class="chk_wrap">
                            <input type="checkbox" id="agree02" name="agree01" v-model="collectAgree">
                            <label for="agree02" class="chk_btn">
                                <span>수집하는 개인정보 항목, 수집 및 이용목적, 보유 및 이용기간에 동의합니다.</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="agreement_box" style="display:none">
                    <h5>마케팅 정보 제공 및 활용 동의 (선택)</h5>
                    <div class="txtBox_wrap">
                        <div class="txtBox">
                            동의내용이 들어가는 공간 <br>
                            동의내용이 들어가는 공간 <br>
                            동의내용이 들어가는 공간 <br>
                            동의내용이 들어가는 공간 <br>
                            동의내용이 들어가는 공간 <br>
                            동의내용이 들어가는 공간 <br>
                            동의내용이 들어가는 공간 <br>
                            동의내용이 들어가는 공간 <br>
                            동의내용이 들어가는 공간 <br>
                            동의내용이 들어가는 공간 <br>
                            동의내용이 들어가는 공간 <br>
                        </div>
                        <div class="radioCheck">
                            <div class="chk_wrap">
                                <input type="checkbox" id="agree03" name="agree01" v-model="marketingAgree">
                                <label for="agree03" class="chk_btn">
                                    <span>마케팅 정보 활용에 동의합니다.</span>
                                </label>
                            </div>
                            <div class="form_wrap">
                                <label for="sms" class="radio_wrap">
                                    <input type="radio" :true-value="'Y'" :false-value="'N'" :value="'Y'" v-model="marketing.sms" @click="toggleRadio('sms')">
                                    <span>문자 수신</span>
                                </label>
                                <label for="email" class="radio_wrap">
                                    <input type="radio" :true-value="'Y'" :false-value="'N'" :value="'Y'" v-model="marketing.email" @click="toggleRadio('email')">
                                    <span>이메일 수신</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn_wrap">
                <button type="button" class="btn_nextStep" @click="nextPage">다음</button>
            </div>
        </div>
    </div>
</div>

</template>
<script>

export default {
  data () {
    return {
      allCheck: false,
      usageAgree: false,
      collectAgree: false,
      marketingAgree: false,
      marketing: {
        sms: 'N',
        email: 'N'
      },
    }
  },

  methods: {
    nextPage() {
      const isValid = this.validation()
        if (isValid) {
          this.$openModal('alertModal', {
            message: isValid
          })
          return
        }
      const {marketing, marketingAgree} = this
      this.$emit('toForm', {marketing, marketingAgree})
    },

    validation() {
      if (!this.usageAgree) return '서비스 이용약관에 동의하셔야 합니다.'
      if (!this.collectAgree) return '개인정보의 제공 및 활용에 <br> 동의하셔야 합니다.'
      else return ''
    },

    updateAllCheck() {
        this.allCheck = this.usageAgree && this.collectAgree && this.marketingAgree;
    },

    toggleRadio(type) {
      if (this.marketing[type] === 'Y') {
        this.marketing[type] = 'N';
      } else {
        this.marketing[type] = 'Y';
      }
    },
  },

  watch: {
    allCheck: {
        handler(newVal) {
            if (newVal === true) {
                this.usageAgree = true
                this.collectAgree = true
                this.marketingAgree = true
                this.marketing.email = 'Y'
                this.marketing.sms = 'Y'
            } else {
                this.usageAgree = false
                this.collectAgree = false
                this.marketingAgree = false
                this.marketing.email = 'N'
                this.marketing.sms = 'N'
            }
        }
    },
    usageAgree: {
        handler() {
            this.updateAllCheck();
        }
    },
    collectAgree: {
        handler() {
            this.updateAllCheck();
        }
    },
    marketingAgree: {
        handler() {
            this.updateAllCheck();
        }
    }
  }
}
</script>
<style lang="">

</style>